import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {FormGroup} from '@angular/forms';
import {BaseFormComponent} from '@shared/base.form-component';
import {IPulseType} from '@shared/models/entities';
import {ContactMethodDTO} from '@staff-app/models/termStaffContactInfoDTO';

@Component({
  selector: 'idp2-phone-number',
  templateUrl: './phone-number.component.html',
  styleUrls: ['./phone-number.component.scss']
})
export class PhoneNumberComponent extends BaseFormComponent implements OnInit {
  showOptIn: boolean;
  selectedEntry: any;
  phoneObj: any;
  error: any;
  public phoneForm: FormGroup;
  ng2TelInputOptions = {
    separateDialCode: true,
    nationalMode: false,
    initialCountry: 'us',
    formatOnDisplay: true,
    preferredCountries: ['us', 'ca', 'gb', 'sg', 'hk']
  };
  telInputObject: any;
  @Input()
  phoneTypes: IPulseType[];
  @Input()
  phoneGroup: FormGroup;
  @Input()
  phoneNumber: ContactMethodDTO;
  @Input()
  set isParentSubmitted(val: boolean) {
    this.submitted = val;
  }
  @Output()
  updatePrimary = new EventEmitter<FormGroup>();
  @Output()
  formReady = new EventEmitter<FormGroup>();

  constructor() {
    super();
  }

  ngOnInit() {
    this.phoneForm = this.phoneGroup;
    if (this.phoneForm.get('phoneType').value) {
      this.updateShowOptIn(this.phoneForm.get('phoneType').value);
    }
    this.loadData();

    this.onValChange();
    this.myForm = this.phoneForm;
  }
  loadData() {
    if (this.phoneForm && this.phoneNumber && this.submitted === false) {
      if (this.telInputObject) {
        this.telInputObject.setNumber(this.phoneNumber.contactDetail);
      }
      this.phoneForm.patchValue({
        phoneType: this.phoneNumber.contactMethodTypeID,
        isOptIn: this.phoneNumber.canAcceptMarketingCommunications
          ? true
          : false
      });

      this.phoneForm.updateValueAndValidity();
      this.formReady.emit(this.phoneForm);
    }
  }

  private getCountryCodePrefix() {
    return '+' + this.telInputObject.getSelectedCountryData().dialCode;
  }

  private getPhoneNumber() {
    if (!this.telInputObject) {
      return;
    }
    const fullNumber: string = this.telInputObject.getNumber();
    const countryCode: string = this.getCountryCodePrefix();

    return fullNumber.replace(countryCode, '');
  }
  updateShowOptIn(phoneType: Enums.ContactMethodType) {
    if (phoneType === Enums.ContactMethodType.CellPhone) {
      this.showOptIn = true;
      this.phoneForm.controls['isOptIn'].setValue(true);
    } else {
      this.showOptIn = false;
      this.phoneForm.controls['isOptIn'].setValue(false);
    }
  }

  onValChange() {
    this.phoneForm.get('phoneType').valueChanges.subscribe(value => {
      this.updateShowOptIn(value);
    });
  }

  onCountryChange(countryObj) {
    this.phoneForm.controls['countryCode'].setValue(countryObj.dialCode);
    this.phoneForm.controls['countryCode'].updateValueAndValidity();
    this.hasError(null);
  }

  getNumber(obj) {
    this.phoneForm.controls['fullPhoneNumber'].setValue(obj);
  }

  getTelInputObject(obj) {
    this.telInputObject = obj;
    if (this.phoneNumber) {
      this.phoneForm.controls['countryCode'].setValue(
        this.telInputObject.getSelectedCountryData().dialCode
      );
      this.phoneForm.controls['phoneNumber'].setValue(this.getPhoneNumber());
    } else {
      this.phoneForm.controls['countryCode'].setValue('1');
    }
  }

  hasError($event : any): void {
    if (this.telInputObject) {
      const isValidNumber = this.telInputObject.isValidNumber();
      const errNumber = this.telInputObject.getValidationError()
      if (this.phoneForm.value.phoneNumber == '' 
        || errNumber != 0
        //|| !isValidNumber
      ) {
        this.phoneForm.get('phoneNumber').setErrors({invalid: true});
      } else {
        this.phoneForm.get('phoneNumber').setErrors(null);
        this.phoneForm.get('phoneNumber').markAsTouched();
        this.phoneForm.get('phoneNumber').updateValueAndValidity();

        if(!isValidNumber) {  //JOB-62  We have to hack this so it will allow invalid area codes that are newly added, to avoid having to upgrade our PHONE util library.
          this.phoneForm.get('fullPhoneNumber').setValue(this.getCountryCodePrefix() + this.phoneForm.value.phoneNumber);
          this.phoneForm.get('fullPhoneNumber').setErrors(null);
          this.phoneForm.get('fullPhoneNumber').markAsTouched();
          this.phoneForm.get('fullPhoneNumber').updateValueAndValidity();
        }
      }
    }
  }
}
